import "uno.css";
import { createApp, h } from "vue";
import App from "./App.vue";
import permissionsDirective from "./common/permission";
import { installRouter } from "./router";
import installPlugins from "./plugins";

async function startUp() {
  const app = createApp({
    render: () => h(App),
    beforeCreate() {
      app.directive("permissions", permissionsDirective());
    },
  });

  installPlugins(app);

  await installRouter(app);

  app.mount("#app");
}

startUp();
